/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-array-index-key */ /* eslint-disable radix */ /* eslint-disable no-unused-vars */
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Box,
  Stepper,
  Step,
  StepLabel,
  Typography,
  CircularProgress,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useLocation, useParams, useHistory } from "react-router-dom";
import CompanyShareholderInfo from "../../components/IEPFReport/CompanyShareholderInfo";
import TransferDetails from "../../components/IEPFReport/TransferDetails";
import StatusInformation from "../../components/IEPFReport/StatusInformation";
import DividendInformation from "../../components/IEPFReport/DividendInformation";
import RequiredDocuments from "../../components/IEPFReport/RequiredDocuments";
import { HINT_FORM_TEXT, ROUTES, STEPS } from "../../constants";

import useStyles from "./styles";
import {
  getInitialDividendEntry,
  getInitialDocumentEntries,
  INITIAL_DIVIDEND_ENTRY,
  INITIAL_DOCUMENT_ENTRIES,
  INITIAL_FORM_DATA,
  INITIAL_NOTIFICATION,
} from "./initialState";
import useFormHandlers from "../../hooks/useFormHandlers";
import useDocumentHandlers from "../../hooks/useDocumentHandlers";
import {
  createTicket,
  fetchTicketById,
  fetchTicketDocuments,
  prepareDividendEntriesFromTicket,
  prepareFormDataFromTicket,
  triggerEmail,
  updateTicket,
  deleteTicket, // NEW: Import deleteTicket
} from "./ticketService";
import RemarkField from "../../components/IEPFReport/RemarkField";
import { API } from "../../apis/api";
import ConformationModal from "../../components/QuestionModal/ConformationModal";
import { errorSnackbar } from "../../redux/features/customSnackbar/action";

const IEPFReport = () => {
  const { isRTA, isAuditor, isAdmin,isPerformer,userId } = useSelector((state) => state.auth.user);
  const dispatch=useDispatch()
  const history = useHistory();
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [ticketCode, setTicketCode] = useState("");
  const [ticketId, setTicketId] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFinishLoading, setIsFinishLoading] = useState(false);
  const [isDocumentValidationComplete, setIsDocumentValidationComplete] =
    useState(false);
  const [notification, setNotification] = useState(INITIAL_NOTIFICATION);
  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [dividendEntries, setDividendEntries] = useState(
    getInitialDividendEntry()
  );
  const [documentEntries, setDocumentEntries] = useState(
    []
  );
  const [caseTypeOptions, setCaseTypeOptions] = useState([]);
  const [isSendBackToRTALoading,setIsSendBackToRTALoading]=useState(false)
  const [isSendToPerformerLoading,setIsSendToPerformerLoading] = useState(false)
  const { queryTicketId } = useParams();

  const isEditMode = !!queryTicketId;

  // NEW: States for custom modal
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingLocation, setPendingLocation] = useState(null);

  // NEW: Flag for ticket submission/completion
  const [isTicketCompleted, setIsTicketCompleted] = useState(false);

  // Ref to store the unblock function
  const unblockRef = useRef(null);
  const handleGoBack =()=> history.goBack()

  const isDisabled = isAuditor || formData.status === "closed";

  const showNotification = (message, severity = "info") => {
    setNotification((prev) => ({
      open: true,
      message,
      severity,
      key: prev.key + 1,
    }));
  };

  const {
    handleChange,
    handleAddDividend,
    handleDividendChange,
    handleRemoveDividend,
  } = useFormHandlers(setFormData, setDividendEntries);

  const {
    handleAddDocument,
    handleDocumentChange,
    handleDocumentFileChange,
    handleDocumentUpload,
    handleRemoveDocument,
    getDocumentDownloadUrl,
  } = useDocumentHandlers(
    documentEntries,
    setDocumentEntries,
    ticketId,
    ticketCode,
    showNotification,
    userId
  );

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  const handleDocumentValidationChange = (isValid) => {
    setIsDocumentValidationComplete(isValid);
  };

const selectedChecklist = useMemo(() => {
  const caseTypeValue = Array.isArray(formData.caseType)
    ? formData.caseType[0]
    : formData.caseType;

  return caseTypeOptions.find(
    (item) => item.name?.toLowerCase?.() === caseTypeValue?.toLowerCase?.()
  );
}, [caseTypeOptions, formData.caseType]);

  const checklistId = selectedChecklist?.id || null;

  const handleSubmitTicket = async (e) => {
    e.preventDefault();
    // Since input is restricted, only check for required fields
    const requiredFields = [
      "companyName",
      "shareholderName",
      "claimantName",
      "beneficiaryAccount",
      "securityType",
      "numberOfShares",
      "shareFaceValue",
      "transferDate",
      "status",
      "caseType",
    ];
    for (const field of requiredFields) {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        showNotification(
          "Please fill all required fields before submitting",
          "error"
        );
        return;
      }
    }
    setIsLoading(true);
    try {
      if (isEditMode) {
        const response = await updateTicket(
          ticketCode,
          formData,
          dividendEntries,
          userId,
        );
        if (response && response.data) {
          showNotification(
            `Ticket updated successfully! Ticket Code: ${response.data.data.ticket_code}`,
            "success"
          );
        } else {
          throw new Error("No ticket code received");
        }
      } else {
        const response = await createTicket(formData, dividendEntries,userId);
        if (response && response.ticket_id) {
          setTicketCode(response.ticket_code);
          setTicketId(response.ticket_id);
          setActiveStep(1);
          showNotification(
            `Ticket created successfully! Ticket Code: ${response.ticket_code}`,
            "success"
          );
        } else {
          throw new Error("No ticket code received");
        }
      }
    } catch (err) {


      const errorData = err.response?.data?.error;

if (err.response?.status === 400 && errorData) {
  const errorMessages = [];

  for (const key in errorData) {
    if (Object.prototype.hasOwnProperty.call(errorData, key)) {
      const fieldError = errorData[key];

      // For array of nested objects (e.g. dividend_info)
      if (Array.isArray(fieldError) && typeof fieldError[0] === "object") {
        fieldError.forEach((nestedObj, index) => {
          for (const nestedKey in nestedObj) {
            if (Object.prototype.hasOwnProperty.call(nestedObj, nestedKey)) {
              const nestedErrors = nestedObj[nestedKey];
              if (Array.isArray(nestedErrors)) {
                nestedErrors.forEach((msg) => {
                  errorMessages.push(
                    `${key}[${index}].${nestedKey}: ${msg}`
                  );
                });
              }
            }
          }
        });
      }

      // For regular field errors (e.g. demat_id)
      else if (Array.isArray(fieldError)) {
        fieldError.forEach((msg) => {
          errorMessages.push(`${key}: ${msg}`);
        });
      }
    }
  }

  const combinedError = errorMessages.join("\n");
  // dispatch(errorSnackbar({
  //   title:"Ticket creation error",
  //   subtitle:`${combinedError}`,
  //   duration:5000,
  // }))
  showNotification(combinedError, "error");
} else {
  showNotification(
    "An unexpected error occurred. Please try again.",
    "error"
  );
}

      // console.error("Ticket creation error:", err);
      // showNotification(
      //   err.response?.data?.message ||
      //     "Failed to create ticket. Please try again.",
      //   "error"
      // );
    } 
    finally {
      setIsLoading(false);
    }
  };

  const resetForm = () => {
    setFormData(INITIAL_FORM_DATA);
    setDividendEntries(getInitialDividendEntry());
    setDocumentEntries([]);
    setTicketCode("");
    setTicketId("");
    setActiveStep(0);
    setIsLoading(false);
    setIsFinishLoading(false);
    setIsDocumentValidationComplete(false);
    setIsTicketCompleted(false); // NEW: Reset completion flag
  };

  const handleFinish = async () => {
    if (!isDocumentValidationComplete) {
      showNotification(
        "Please complete all required document uploads before finishing",
        "error"
      );
      return;
    }
    setIsFinishLoading(true);
    try {
      const response = await triggerEmail(ticketId,userId);
      if (response) {
        setIsTicketCompleted(true);
        showNotification("Process completed successfully!", "success");
        resetForm();
      }
    } catch (err) {
      console.error("Error triggering email:", err);
      showNotification("Failed to trigger email notification", "error");
    } finally {
      setIsFinishLoading(false);
    }
  };

  const sendBackToRTA = async () => {
    setIsSendBackToRTALoading(true)
    try {
      const payload = {
        ticket_code: ticketCode,
        sub:userId,
        ticket_status: "RTA_RECTIFY",
      };

      const response = await API.post("ticket/update-ticket-status/", payload);

      if (response) {
        showNotification("Ticket successfully sent back to RTA", "success");
        history.goBack();
      }
    } catch (error) {
      console.error(`Error sending ticket ${ticketId} back to RTA:`, error);
    } finally{
      setIsSendBackToRTALoading(false)
    }
  };

  const sendBackToPerformer = async () => {
    setIsSendToPerformerLoading(true)
    try {
      const payload = {
        ticket_code: ticketCode,
        sub:userId,
        ticket_status: "RTA_APPROVED",
      };

      const response = await API.post("ticket/update-ticket-status/", payload);

      if (response) {
        showNotification("Ticket successfully sent back to RTA", "success");
        history.goBack();
      }
    } catch (error) {
      console.error(`Error sending ticket ${ticketId} back to RTA:`, error);
    } finally{
      setIsSendToPerformerLoading(false)
    }
  };

  useEffect(() => {
    const initEditMode = async () => {
      if (isEditMode && queryTicketId) {
        try {
          const ticketData = await fetchTicketById(queryTicketId,userId); // API returns { id, ticket_code, ... }

          // Transform and set the data
          setTicketId(ticketData.id); // numeric ID
          setTicketCode(ticketData.ticket_code); // TK-xxxx

          const transformedFormData = prepareFormDataFromTicket(ticketData);
          const transformedDividends = prepareDividendEntriesFromTicket(
            ticketData.dividend_info || INITIAL_DIVIDEND_ENTRY
          );

          setFormData(transformedFormData);
          setDividendEntries(transformedDividends);

          const ticketDocuments = await fetchTicketDocuments(queryTicketId,userId);
          if (ticketDocuments) {
            const existingDocuments = ticketDocuments;

            // Update document entries with existing documents
            setDocumentEntries((prevEntries) => {
              const updatedEntries = [...prevEntries];

              existingDocuments.forEach((doc) => {
                const existingIndex = updatedEntries.findIndex(
                  (entry) => entry.documentType === doc.document_type
                );

                if (existingIndex !== -1) {
                  // Update existing entry
                  updatedEntries[existingIndex] = {
                    ...updatedEntries[existingIndex],
                    documentCode: doc.document_code,
                    file: null, // We don't have the file object, just the reference
                    fileName: doc.file_name,
                    filePath: doc.file_path,
                    isUploading: false,
                  };
                } else {
                  // Add new entry for documents not in initial entries
                  updatedEntries.push({
                    documentType: doc.document_type,
                    file: null,
                    documentCode: doc.document_code,
                    fileName: doc.file_name,
                    filePath: doc.file_path,
                    isUploading: false,
                  });
                }
              });

              return updatedEntries;
            });
          }
        } catch (err) {
          console.error(err);
          showNotification(
            err.response?.data?.message || "Failed to load ticket info.",
            "error"
          );
        }
      }
    };

    initEditMode();
  }, [isEditMode, queryTicketId]);

  const showSendBackToRTAButton = () => {
    if (!isEditMode) return false;
    if (isRTA || isAuditor) return false;

    const invalidStatuses = ["rectify", "reject"];
    return !invalidStatuses.includes(formData.status);
  };

  const showSendBackToPerformerButton = () => {
    if (!isEditMode) return false;

    const isAdminOrRTA = isAdmin || isRTA;
    const isRtaRectify = formData.status === "rectify";

    return isAdminOrRTA && isRtaRectify;
  };

  const commonComponents = () => (
    <>
      <CompanyShareholderInfo
        formData={formData}
        handleChange={handleChange}
        hintFormText={HINT_FORM_TEXT}
        disable={isDisabled}
      />
      <TransferDetails
        formData={formData}
        handleChange={handleChange}
        hintFormText={HINT_FORM_TEXT}
        disable={isDisabled}
      />
      <StatusInformation
        formData={formData}
        handleChange={handleChange}
        hintFormText={HINT_FORM_TEXT}
        disable={isDisabled}
        isEditMode={isEditMode}
        setCaseTypeOptions={setCaseTypeOptions}
      />
      <DividendInformation
        dividendEntries={dividendEntries}
        handleDividendChange={handleDividendChange}
        handleAddDividend={handleAddDividend}
        handleRemoveDividend={handleRemoveDividend}
        disabled={isDisabled}
      />
    </>
  );

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <form onSubmit={handleSubmitTicket}>
            {commonComponents()}
            <RemarkField
              formData={formData}
              handleChange={handleChange}
              disable={isDisabled}
            />
            {!isAuditor && (
              <Box display="flex" justifyContent="center">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.button}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} /> : "Create Ticket"}
                </Button>
              </Box>
            )}
          </form>
        );
      case 1:
        return (
          <div className={classes.documentContainer}>
            <Typography variant="h6" gutterBottom>
              Ticket Code: {ticketCode}
            </Typography>
            <RequiredDocuments
              documentEntries={documentEntries}
              setDocumentEntries={setDocumentEntries}
              checklistId={checklistId}
              handleDocumentChange={handleDocumentChange}
              handleDocumentFileChange={handleDocumentFileChange}
              handleDocumentUpload={handleDocumentUpload}
              handleAddDocument={handleAddDocument}
              handleRemoveDocument={handleRemoveDocument}
              onValidationChange={handleDocumentValidationChange}
              getDocumentDownloadUrl={getDocumentDownloadUrl}
              disabled={isDisabled}
            />

            <div className={classes.finishButtonContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFinish}
                className={classes.button}
                disabled={isFinishLoading || !isDocumentValidationComplete}
              >
                {isFinishLoading ? (
                  <>
                    <CircularProgress size={20} style={{ marginRight: 8 }} />
                    Processing...
                  </>
                ) : (
                  "Finish"
                )}
              </Button>
              {!isDocumentValidationComplete && (
                <Typography
                  variant="body2"
                  color="error"
                  className={classes.validationMessage}
                >
                  Complete all required document uploads to finish the ticket
                </Typography>
              )}
            </div>
          </div>
        );
      default:
        return "Unknown step";
    }
  };

  const handleCancelLeave = () => {
    setShowConfirmModal(false);
    setPendingLocation(null);
  };

  const shouldDeleteTicket = useCallback(
    () => !isEditMode && !isTicketCompleted && activeStep === 1,

    [isEditMode, isTicketCompleted, activeStep]
  );

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (shouldDeleteTicket()) {
      const unblock = history.block((location) => {
        setPendingLocation(location);
        setShowConfirmModal(true);
        return false;
      });

      // Store unblock function in ref
      unblockRef.current = unblock;

      return () => {
        unblock();
        unblockRef.current = null;
      };
    }
    // Clear unblock function when not blocking
    unblockRef.current = null;
  }, [activeStep, isTicketCompleted, isEditMode, history, shouldDeleteTicket]);

  const handleConfirmLeave = async () => {
    setShowConfirmModal(false);

    if (unblockRef.current) {
      unblockRef.current();
      unblockRef.current = null;
    }

    if (ticketCode) {
      try {
        await deleteTicket(ticketCode,userId);
        showNotification("Ticket deleted due to incomplete process.", "info");
      } catch (err) {
        showNotification("Failed to delete ticket.", "error");
      }
    }

    if (pendingLocation) {
      history.push(pendingLocation.pathname);
    }

    setPendingLocation(null);
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (shouldDeleteTicket()) {
        e.preventDefault();
        e.returnValue =
          "If you leave this page before completing the ticket, the ticket will be deleted. Are you sure?";
      }
    };

    const handleUnload = () => {
      if (shouldDeleteTicket()) {
        deleteTicket(ticketCode);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, [activeStep, isTicketCompleted, isEditMode, ticketId, shouldDeleteTicket]);

  return (
    <div className={classes.root}>
      {!isEditMode && (
        <Stepper activeStep={activeStep} className={classes.stepperRoot}>
          {STEPS.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}
      {isEditMode ? (
        <>
          <form onSubmit={handleSubmitTicket} className={classes.form}>
            {ticketCode && (
              <Box mx={4} className={classes.headerContainer}>
                <Typography variant="h6" gutterBottom>
                  Ticket Code: {ticketCode}
                </Typography>
                <Button
                  variant="contained"
                  color="default"
                  startIcon={<ArrowBackIcon />}
                  onClick={() => handleGoBack()}
                  className={classes.backButton}
                >
                  Back
                </Button>
              </Box>
            )}
            {commonComponents()}
            <Box mt={2} m={4}>
              <RequiredDocuments
                disabled={isDisabled}
                documentEntries={documentEntries}
                setDocumentEntries={setDocumentEntries}
                checklistId={checklistId}
                handleDocumentChange={handleDocumentChange}
                handleDocumentFileChange={handleDocumentFileChange}
                handleDocumentUpload={handleDocumentUpload}
                handleAddDocument={handleAddDocument}
                handleRemoveDocument={handleRemoveDocument}
                onValidationChange={handleDocumentValidationChange}
                getDocumentDownloadUrl={getDocumentDownloadUrl}
              />
            </Box>
            <RemarkField
              formData={formData}
              handleChange={handleChange}
              disable={isDisabled}
            />
            {!isAuditor && (
              <Box>
                {!isDisabled && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    style={{ gap: 20 }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.button}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "Update Ticket"
                      )}
                    </Button>
                    {showSendBackToRTAButton() && (
                      <>
                        <Button
                          type="button"
                          variant="contained"
                          color="secondary"
                          size="large"
                          className={`${classes.button} ${classes.rejectBtn}`}
                          disabled={isSendBackToRTALoading}
                          onClick={sendBackToRTA}
                        >
                          {isSendBackToRTALoading ? (
                            <CircularProgress size={24} />
                          ) : (
                            "Send Back to RTA"
                          )}
                        </Button>
                        {!isPerformer && (
                          <Button
                            type="button"
                            variant="contained"
                            color="secondary"
                            size="large"
                            className={`${classes.button} ${classes.rejectBtn}`}
                            disabled={isSendToPerformerLoading}
                            onClick={sendBackToPerformer}
                          >
                            {isSendToPerformerLoading ? (
                              <CircularProgress size={24} />
                            ) : (
                              "Send to Performer"
                            )}
                          </Button>
                        )}
                      </>
                    )}
                    {showSendBackToPerformerButton() && (
                      <Button
                        type="button"
                        variant="contained"
                        color="secondary"
                        size="large"
                        className={`${classes.button} ${classes.rejectBtn}`}
                        disabled={isSendToPerformerLoading}
                        onClick={sendBackToPerformer}
                      >
                        {isSendToPerformerLoading ? (
                          <CircularProgress size={24} />
                        ) : (
                          "Send to Performer"
                        )}
                      </Button>
                    )}
                  </Box>
                )}
              </Box>
            )}
          </form>
        </>
      ) : (
        getStepContent(activeStep)
      )}
      <Snackbar
        key={notification.key}
        open={notification.open}
        autoHideDuration={3000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div className={`${classes.notification} ${notification.severity}`}>
          <Typography variant="body1">{notification.message}</Typography>
        </div>
      </Snackbar>

      <ConformationModal
        open={showConfirmModal}
        handleConformation={handleConfirmLeave}
        handleClose={handleCancelLeave}
        message="If you leave this page before uploading the document, the ticket will be deleted. Are you sure?"
      />
    </div>
  );
};

export default IEPFReport;